import { render, staticRenderFns } from "./MallShopAdd.vue?vue&type=template&id=2ca2e9da&scoped=true&"
import script from "./MallShopAdd.vue?vue&type=script&lang=js&"
export * from "./MallShopAdd.vue?vue&type=script&lang=js&"
import style0 from "./MallShopAdd.vue?vue&type=style&index=0&id=2ca2e9da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca2e9da",
  null
  
)

export default component.exports